import type { AdminRole } from '@/lib/api-admin';

/**
 * Notification operations route guard. Slice 19 본 구현 진입 전까지 진입 가능한
 * role 만 정의 — 본 구현 시 templates CRUD / DLQ replay / 발송 history 각 액션별
 * RBAC 세분화 예정.
 */
export const NOTIFICATION_ROUTE_ROLES: ReadonlyArray<AdminRole> = [
  'OPS_ADMIN',
  'SUPER_ADMIN',
];

/**
 * 템플릿 read RBAC — list / detail 조회 가능 역할. BE
 * `AdminNotificationController` 의 GET endpoint 매핑과 정합 (SUPER_ADMIN /
 * OPS_ADMIN / CS_AGENT / AUDITOR).
 */
export const NOTIFICATION_TEMPLATE_READ_ROLES: ReadonlyArray<AdminRole> = [
  'SUPER_ADMIN',
  'OPS_ADMIN',
  'CS_AGENT',
  'AUDITOR',
];

/**
 * 템플릿 write RBAC — POST / PUT / DELETE 가능 역할. BE
 * `AdminNotificationController` 의 mutation endpoint 매핑과 정합.
 */
export const NOTIFICATION_TEMPLATE_WRITE_ROLES: ReadonlyArray<AdminRole> = [
  'SUPER_ADMIN',
  'OPS_ADMIN',
];

/**
 * 메시지(알림톡) 단일 페이지 진입 read RBAC — 5탭 통합 페이지/사이드바 엔트리에 적용.
 * 템플릿 read 와 동일(조회 가능 역할). 탭 내부 write 액션은 각 write 역할로 2차 게이트.
 */
export const NOTIFICATION_PAGE_READ_ROLES: ReadonlyArray<AdminRole> =
  NOTIFICATION_TEMPLATE_READ_ROLES;

/**
 * 연동(발신번호/카카오채널/발송제한) write RBAC. 스펙 §7 — SUPER_ADMIN / OPS_ADMIN.
 * 발송(광고성/테스트/재발송) write 도 동일 운영자 권한 묶음을 재사용한다.
 */
export const NOTIFICATION_INTEGRATION_WRITE_ROLES: ReadonlyArray<AdminRole> = [
  'SUPER_ADMIN',
  'OPS_ADMIN',
];
